import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PortfolioGanttViewComponent } from './portfolio-gantt-view.component';

const routes: Routes = [
  {
    path: '',
    component: PortfolioGanttViewComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PortfolioGanttViewRoutingModule { }
